import {
  LOADING_TRUE,
  RESET_MODAL,
  LOADING_FALSE,
  LICENSE_ORDER_LIST_START,
  LICENSE_ORDER_LIST,
  LICENSE_ORDER_LIST_FAIL,
  LICENSE_ORDER_DETAIL_START,
  LICENSE_ORDER_DETAIL,
  LICENSE_ORDER_DETAIL_FAIL,
  LOGOUT_USER,
} from "../constants/constants";
import axios from "axios";
import authHeader from "../../api/authToken";
import { ShowAlert } from "./alertActions";

export const getLicenseOrderList = (workspaceId) => async (dispatch) => {
  dispatch({
    type: LOADING_TRUE,
  });
  dispatch({
    type: LICENSE_ORDER_LIST_START,
  });
  try {
    // let body = JSON.stringify({ workspace_id: workspaceId });
    const request = await axios.post(
      `${process.env.REACT_APP_API_URL}/order/license-certifications/index`,
      {},
      { headers: authHeader() }
    );
    const results = await request.data;

    dispatch({
      type: LICENSE_ORDER_LIST,
      payload: results,
    });
    dispatch({
      type: LOADING_FALSE,
    });
  } catch (e) {
    dispatch({
      type: LICENSE_ORDER_LIST_FAIL,
    });
    // dispatch(ShowAlert("Something went wrong", "error"));
    dispatch({
      type: LOADING_FALSE,
    });
  }
};
export const singleLicenseOrder = (body) => async (dispatch) => {
  try {
    dispatch({
      type: LICENSE_ORDER_DETAIL_START,
    });
    let data = JSON.stringify(body);

    const request = await axios.post(
      `${process.env.REACT_APP_API_URL}/order/license-certifications/show/${body}`,
      data,
      { headers: authHeader() }
    );
    const results = await request.data;
    dispatch({
      type: LICENSE_ORDER_DETAIL,
      payload: results,
    });
    dispatch({
      type: LOADING_FALSE,
    });
  } catch (e) {
    dispatch({
      type: LICENSE_ORDER_DETAIL_FAIL,
    });
  }
};
